import { render, staticRenderFns } from "./r-bottom-panel.vue?vue&type=template&id=ff08af78"
import script from "./r-bottom-panel.vue?vue&type=script&lang=js"
export * from "./r-bottom-panel.vue?vue&type=script&lang=js"
import style0 from "./r-bottom-panel.vue?vue&type=style&index=0&id=ff08af78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports